<template>
    <div>
        <v-card flat>
            <v-toolbar dense flat rounded>
                <v-toolbar-title>Credit Notes</v-toolbar-title>
                <v-spacer></v-spacer>
                <p-icon-btn
                    icon="mdi-eye"
                    tooltip="Open"
                    v-if="hasOnlyOneSelected"
                    @click="openCreditNoteDisplay"
                ></p-icon-btn>
                <p-icon-btn
                    icon="mdi-refresh"
                    tooltip="Refresh"
                    @click="refresh"
                ></p-icon-btn>
                <credit-notes-search-menu
                    @submit="handleSearchMenuSubmit"
                    v-model="searchMenuShown"
                    :search.sync="search"
                ></credit-notes-search-menu>
                <p-menu :items="menuItems"></p-menu>
            </v-toolbar>
            <v-card-text>
                <credit-note-data-table
                    ref="creditNoteDataTable"
                    :search="search"
                    v-model="selected"
                >
                </credit-note-data-table>
            </v-card-text>
        </v-card>
        <credit-note-display
            v-model="creditNoteDisplayShown"
            v-if="creditNoteDisplayShown"
            :credit-note="selectedCreditNote"
            @updated="refresh"
        >
        </credit-note-display>
        <credit-notes-dialog
            v-if="creditNoteDialogShown"
            v-model="creditNoteDialogShown"
            :id="selectedCreditNote.id"
            @submit="refresh"
        >
        </credit-notes-dialog>
        <p-alert
            v-if="alert.display"
            v-model="alert.display"
            :title="alert.title"
            :content="alert.content"
            :callback="alert.callback">
        </p-alert>
    </div>
</template>
<script>
import { isEmpty } from "lodash";

import { deleteCreditNote } from "../../services/sales/creditNote";

import PIconBtn from "../../components/common/PIconBtn.vue";
import PMenu from "../../components/common/PMenu.vue";
import CreditNoteDataTable from "../../components/Sales/CreditNoteDataTable.vue";
import CreditNotesSearchMenu from "../../components/Sales/CreditNotesSearchMenu.vue";
import CreditNoteDisplay from "../../components/Sales/CreditNoteDisplay";
import CreditNotesDialog from "../../components/Sales/CreditNotesDialog";
import PAlert from "../../components/common/PAlert";


export default {
    name: "CreditNotes",
    components: {
        PMenu,
        PIconBtn,
        CreditNoteDataTable,
        CreditNotesSearchMenu,
        CreditNoteDisplay,
        CreditNotesDialog,
        PAlert,
    },
    data() {
        return {
            selected: [],
            loading: {},
            creditNotes: [],
            options: {},
            creditNoteDisplayShown: false,
            creditNoteDialogShown: false,
            searchMenuShown: false,
            search: {},
            alert: {}
        };
    },
    computed: {
        menuItems() {
            return [
                {
                    text: "New",
                    icon: "mdi-plus-circle",
                    ability: this.canCreate,
                    callback: this.openCreditNoteDialogCreate,
                },
                {
                    text: "Edit",
                    icon: "mdi-pencil",
                    ability: this.canUpdate,
                    callback: this.openCreditNoteDialogEdit,
                    display: this.hasOnlyOneSelected,
                },
                {
                    text: "Delete",
                    icon: "mdi-delete",
                    ability: this.canDelete,
                    callback: this.confirmDeleting,
                    display: this.hasOnlyOneSelected,
                },
            ];
        },
        canCreate() {
            return true;
        },
        canUpdate() {
            return true;
        },
        canDelete() {
            return true;
        },
        hasOnlyOneSelected() {
            return this.selected.length === 1;
        },
        selectedCreditNote() {
            return isEmpty(this.selected) ? {} : this.selected[0];
        },
    },
    methods: {
        openCreditNoteDisplay() {
            this.creditNoteDisplayShown = true;
        },
        openCreditNoteDialogCreate() {
            this.selected = [];
            this.creditNoteDialogShown = true;
        },
        openCreditNoteDialogEdit() {
            this.creditNoteDialogShown = true;
        },
        refresh() {
            this.$refs.creditNoteDataTable.fetchCreditNoteData();
        },
        handleSearchMenuSubmit() {
            this.searchMenuShown = false;
            this.refresh();
        },
        deleteCreditNoteData() {
            deleteCreditNote(this.selectedCreditNote.id).then(() => {
                this.refresh();
            });
        },
        openAlertDialog({ title, content, callback }) {
            this.alert = {
                ...this.alert,
                display: true,
                title,
                content,
                callback,
            };
        },
        confirmDeleting() {
            this.openAlertDialog({
                title: "Confirm Deleting",
                content:
                    "Are you sure you want to delete this credit note! This action cannot be undone!",
                callback: this.deleteCreditNoteData,
            });
        },
    }
};
</script>
